export default __webpack_public_path__ + "static/793-233b91abb628cd6bb7f2ae8f3773b643.gif";